import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MediaTypes } from '../../enums/media-types';
import { ImgOrVideo } from '../../types/media-type';

@Component({
  selector: 'app-media-adder-item-condensed',
  templateUrl: './media-adder-item-condensed.component.html',
  styleUrls: ['./media-adder-item-condensed.component.scss'],
})
export class MediaAdderItemCondensedComponent {
  @Input() sectionFormControl: FormControl;
  @Input() mediaType: `${MediaTypes}`;
  @Input() addMediaLabel: string;
  @Input() cssIconClass: string;
  @Input() isDisabled: boolean;
  @Output() handleAddMedia = new EventEmitter<`${MediaTypes}`>();
  @Output() handleRemoveMedia = new EventEmitter<{
    mediaToRemove: ImgOrVideo;
    mediaIndexToRemove: number;
  }>();

  @ContentChild(TemplateRef) templateOutlet!: TemplateRef<any>;

  MEDIA_TYPES = MediaTypes;
  imageCaptureControl: FormControl<string>;
}
